<template>
  <div class="container">
    <button
      class="toggle-btn"
      :class="{ active: isKeywordShown }"
      type="button"
      @click="toggleIsActive()"
      data-v-step="toggle-marker-purchases"
    >
      <span></span>
      <span>Подсветить ключевые слова</span>
    </button>

    <div
      class="switcher-color"
      :class="{ 'icon-disabled': !isKeywordShown }"
      :style="{ backgroundColor: getActualColor }"
      @click="toggleColorPicker"
      ref="colorPickerRef"
      >
      <button
        class="btn-color-key"
        type="button"
      >Ключевое слово</button>
      <ico name="icoArrowDropDown" color="#263239" size="20px"></ico>

      <transition name="fade-colorPicker">
        <div v-if="isColorPickerVisible" class="color-picker">
          <div
              v-for="(color, index) in colors"
              :key="index"
              class="color-circle"
              :style="{ backgroundColor: color }"
              :class="{ selected: currentColor === color }"
              @click.stop="selectColor(color)"
              @mouseenter="hoverColor = color"
              @mouseleave="hoverColor = null"
            >
            <img
              v-if="currentColor === color"
              class="check-icon"
              src='../../assets/img/ico-color.svg'
              alt="check-color"
            />
          </div>
        </div>
      </transition>
    </div>

    <Hint class="hint-colors" style="right: 0">
      <div class="hint-content" style="min-width: 300px">
        <p>
          При отключении данной опции в поисковой выдаче фильтра ключевые слова не будут выделены
        </p>
      </div>
    </Hint>
    <img
        style="display: none;"
        src='../../assets/img/ico-color.svg'
        alt="preload"
      />

  </div>

</template>

<script>
import { mapActions, mapGetters } from 'vuex/dist/vuex.common.js';
import Hint from '../common/Hint'

export default {
  name: "ToggleMarkerBtn",
  components: {
    Hint
  },
  data() {
    return {
      test: JSON.parse(localStorage.getItem('marker')),
      gridApi: null,
      isColorPickerVisible: false,
      colors: ['#BDD2FF', '#FFDEC5', '#FFE7A8', '#C6F6C0'],
      hoverColor: null
    };
  },
  computed: {
    ...mapGetters('purchasesTableSettings', ['isActiveSearch', 'isKeywordShown', 'keywordsColor']),
    ...mapGetters('filterTabs', ['currentTab']),
    currentColor() {
      return this.keywordsColor;
    },
    getActualColor() {
      return this.hoverColor || (this.isKeywordShown ? this.currentColor : this.keywordsColor);
    }
  },
  watch: {
      keywordsColor(newColor) {
        if (newColor) {
          document.documentElement.style.setProperty('--marker-main-color', newColor);
        }
      },
      isKeywordShown(newVal) {
        if (newVal && this.keywordsColor) {
          document.documentElement.style.setProperty('--marker-main-color', this.keywordsColor);
        }
      }
  },
  methods: {
    ...mapActions('purchasesTableSettings', ['updateIsKeywordShown', 'updateIsActiveSearch', 'updateKeywordsColor']),

    async toggleIsActive() {
      try {
        const newState = !this.isKeywordShown;
        await this.updateIsKeywordShown(newState);
        this.updateIsActiveSearch({
          isActiveSearch: this.isActiveSearch,
          routeId: this.$route.params.id,
          routeQuery: this.$route.query
        })
      } catch (e) {
        this.$toast.error(e.message);
      }
    },
    toggleColorPicker() {
      if (!this.isKeywordShown) return;
      this.isColorPickerVisible = !this.isColorPickerVisible;
    },
    selectColor(color) {
      this.updateKeywordsColor(color);
      this.isColorPickerVisible = false;
    },
    handleClickOutside(event) {
      const colorPicker = this.$refs.colorPickerRef;
      if (this.isColorPickerVisible && colorPicker && !colorPicker.contains(event.target)) {
        this.isColorPickerVisible = false;
      }
    },
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside);
  },
  created() {
    if (this.keywordsColor) {
      document.documentElement.style.setProperty('--marker-main-color', this.keywordsColor);
    }
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/less/variables.less";

.container{
    display: flex;
    gap: 10px;
}
p {
  letter-spacing: 0.3px;
  color: white;
}

.toggle-btn {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 16px;

  span {
    &:first-child {
      position: relative;
      display: block;
      margin-right: 16px;
      border-radius: 12px;
      width: 48px;
      height: 24px;
      background-color: @bg-color-middle;
      transition: @trans;

      &::before {
        content: "";
        position: absolute;
        left: 3px;
        top: 2px;
        border-radius: 50%;
        width: 20px;
        height: 20px;
        background-color: #ffffff;
        transition: @trans;
      }
    }
  }

  &.active {
    span:first-child {
      background-color: @bg-color-dark;

      &::before {
        left: 25px;
      }
    }
  }
}

.hint {
  right: 0;

  &-wrapper{
    margin-top: 3px;
  }
}

.switcher-color {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 16px;
  padding: 1px 0 1px 6px;
  background-color: #DADBDD;
  border-radius: 5px;
  cursor: pointer;
  position: relative;

  .btn-color-key {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 12px;
  }

  .color-picker {
    display: flex;
    gap: 5px;
    padding: 8px;
    position: absolute;
    border-radius: 20px;
    top: 30px;
    background-color: #ffffff;
    width: 132px;
    height: 42px;
    z-index: 1000;
    box-shadow: 1px 2px 5px 0 rgba(0, 0, 0, 0.5);
    pointer-events: none;

    .color-circle {
      position: relative;
      width: 26px;
      height: 26px;
      border-radius: 50%;
      pointer-events: auto;

      &:hover {
        border: 2px solid rgba(125, 145, 155, 1);
      }

      .check-icon {
        position: absolute;
        top: 50%;
        left: 50%;
        width: 14px;
        height: 14px;
        transform: translate(-50%, -50%);
        pointer-events: none;
      }
    }
  }
}

.fade-colorPicker-enter-active,
.fade-colorPicker-leave-active {
  transition: opacity 0.4s ease, transform 0.4s ease;
}
.fade-colorPicker-enter-from,
.fade-colorPicker-leave-to {
  opacity: 0;
  transform: translateY(-5px);
}
.fade-colorPicker-enter-to,
.fade-colorPicker-leave-from {
  opacity: 1;
  transform: translateY(0);
}

.icon-disabled {
    opacity: .5;
    pointer-events: none;
}
</style>
